"use client"

import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Edit, Trash2, Zap, Hand } from "lucide-react"
import type { DocumentEvent } from "@/types"

interface ActionCardProps {
	event: DocumentEvent
	isAutomatic: boolean
	onEdit: () => void
	onDelete: () => void
}

export function ActionCard({ event, isAutomatic, onEdit, onDelete }: ActionCardProps) {
	return (
		<Card className="p-3">
			<div className="flex items-start justify-between">
				<div className="flex items-center gap-3 flex-1">
					<div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10">

						{isAutomatic ? <Zap className="h-4 w-4 text-primary" /> : <Hand className="h-4 w-4 text-primary" />}

					</div>
						<h5>{event?.klass?.split("::").pop()}</h5>
						<h5 className="font-medium text-sm">{event.name}</h5>
					<div className="flex-1">

					</div>
				</div>
				<div className="flex gap-1">
					<Button variant="ghost" size="icon" className="h-8 w-8" onClick={onEdit}>
						<Edit className="h-3 w-3" />
					</Button>
					<Button variant="ghost" size="icon" className="h-8 w-8" onClick={onDelete}>
						<Trash2 className="h-3 w-3 text-destructive" />
					</Button>
				</div>
			</div>
		</Card>
	)
}

